import React, { useState, useEffect, useRef } from 'react';
import CreatableSelect from "react-select/creatable";
import axios from 'axios';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { List, arrayMove } from 'react-movable';

import { Button } from 'reactstrap';
import { getExercises, createWorkout, uploadVideo } from './createPlanApi';
import Modal from '../../components/modal/modal';
import './workouts.css';

const config = require('../../config').get(process.env.REACT_APP_ENVIRONMENT);

function saveWorkout({exercises, trainerName, workoutName}) {
  if(exercises && trainerName && workoutName) {
    createWorkout(exercises, workoutName, trainerName)
      .then(res => {
        alert('saved')
      })
      .catch(err => alert(`error: ${err}`))
  } else {
    alert('Missing Parameters')
  } 
}

function exportToWord({exercises, trainerName, workoutName}) {
  let text = '';
  text = `Workout Name: ${workoutName} \n By: ${trainerName} \n Exercises List: \n`

  exercises.forEach(exercise => {
    text += `   ${exercise.present_name}: \n`+
          `         Beginner:      ${exercise.times.beginnerTimeOn}/${exercise.times.beginnerTimeOff} \n` +
          `         Intermediate:  ${exercise.times.intermediateTimeOn}/${exercise.times.intermediateTimeOff} \n`+
          `         Advanced:      ${exercise.times.advancedTimeOn}/${exercise.times.advancedTimeOff} \n`
  })

  return text
}

function MyDialog(props) {
  return <Dialog
          open={props.openDialog}
          onClose={props.closeDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{ props.title}</DialogTitle>
            <DialogContent>
                <p style={{whiteSpace: 'pre-wrap'}}>{props.text}</p>
            </DialogContent>
            <DialogActions>
              <Button onClick={props.closeDialog} color="primary" autoFocus>
                close
              </Button>
          </DialogActions>
        </Dialog>
}

export default function CreateWorkout () {
  const [exerciseMapping, setExerciseMapping] = useState([]);
  const [exercises, setExercises] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [trainerName, setTrainerName] = useState("");
  const [workoutName, setWorkoutName] = useState("");
  const [exerciseName, setExerciseName] = useState("");
  const [times, setTimes] = 
    useState({beginnerTimeOn: "",beginnerTimeOff:"", 
      intermediateTimeOn: "", intermediateTimeOff:"", advancedTimeOn:"", advancedTimeOff:"" })
  const [openDialog, setOpenDialog] = useState(false)
  const [dialogText, setDialogText] = useState("")
  const [dialogTitle, setDialogTitle] = useState("")
  
  useEffect(() => {
    getExercises()
    .then(data => setExerciseMapping(data.map(exercise => createOption(exercise))))
    .catch(err => console.log("err", err))
  },[]);

  const replaceIndexs = (oldIndex, newIndex) => {
    let ex = exercises
    let var1 = exercises[oldIndex]
    let var2 = exercises[newIndex]

    ex[oldIndex] = var2
    ex[newIndex] = var1

    setExercises(ex)
  }

  return (
    <div>
      <div style={{display: 'flex'}}>
        <div className="dataset-right-dev">
          <input className="select-motivation basicInput"  name="trainerName" type="text" 
              value={trainerName} onChange={(e) => setTrainerName(e.target.value)} placeholder="Trainer Name"/>
          <input className="select-motivation basicInput"  name="workoutName" type="text" 
              value={workoutName} onChange={(e) => setWorkoutName(e.target.value)} placeholder="Workout Name"/>
          <div className="exercise-div">
            <p>Exercises:</p>
            <MovableList items={exercises.map(exercise => exercise.present_name)} setItems={replaceIndexs}/>
          </div>
          <Button onClick={() => saveWorkout({exercises, trainerName, workoutName})} className="mr-3" style={{marginLeft: '1vw'}}>Save</Button>
          <Button onClick={() => {
            setDialogText(exportToWord({exercises, trainerName, workoutName}))
            setDialogTitle('Workout Content')
            setOpenDialog(true)
              }} 
              className="mr-3" 
              style={{marginLeft: '1vw'}}>Open Workout</Button>
        </div>
        <div className="video-div-right">
          <div>
          <CreatableAdvanced options={exerciseMapping} value={exerciseName} setValue={setExerciseName} showModal={()=> setShowModal(true)} />
          </div>
            <Times lable="Beginner" times={times} setTimes={setTimes}/>
            <Times lable="Intermediate" times={times} setTimes={setTimes}/>
            <Times lable="Advanced" times={times} setTimes={setTimes}/>
            <Button onClick={() => {
              setExerciseName('')
              setTimes({ beginnerTimeOn: "",beginnerTimeOff:"", 
                intermediateTimeOn: "", intermediateTimeOff:"", advancedTimeOn:"", advancedTimeOff:"" })
              setExercises([...exercises, {present_name: exerciseName.label, _id: exerciseName._id, times }])}} 
              className="mr-3 savebtn" style={{marginLeft: '1vw'}}>Add</Button>
        </div>
      </div>
      { showModal ? <UploadFileModal show={showModal} hideModal={() => setShowModal(false)} trainerName={trainerName} exercise={exerciseName}/> : null}
      { openDialog ? <MyDialog openDialog={openDialog} closeDialog={() => setOpenDialog(false)} text={dialogText} title={dialogTitle} /> : null }
    </div>
  );
}

function Times (props) {
  return (
    <div>
      <p> {props.lable}: </p>
      <div className="times-inputs">
        <input className="select-motivation basicInput"  name="timeOn" type="number" 
          value={props.times[`${props.lable.toLowerCase()}TimeOn`]} 
          onChange={(e) => props.setTimes({...props.times, [`${props.lable.toLowerCase()}TimeOn`]: e.target.value})} placeholder="Time on"/>
        <input className="select-motivation basicInput"  name="timeOff" type="number" 
          value={props.times[`${props.lable.toLowerCase()}TimeOff`]} 
          onChange={(e) => props.setTimes({...props.times, [`${props.lable.toLowerCase()}TimeOff`]: e.target.value})} placeholder="TIme Off"/>
      </div>
    </div>
  )
}

function MovableList(props) {
  const [items, setItems] = useState(props.items);

  useEffect(() => {
    setItems(props.items)
  },[props.items]);

  return (
    <List
      values={items}
      onChange={({ oldIndex, newIndex }) => {
          props.setItems(oldIndex, newIndex)
          setItems(arrayMove(items, oldIndex, newIndex))
        }
      }
      onKeyDown={(env) => console.log(env)}
      renderList={({ children, props }) => <ul {...props} onKeyDown={(env) => console.log(env)}>{children}</ul>}
      renderItem={({ value, props }) => <li {...props} onKeyDown={(env) => console.log(env)}>{value}</li>}
    />
  );
};

function UploadFileModal(props) {
  return (
    <Modal show={props.show} handleClose={props.hideModal} style={{width: '40vw'}}>
      <div>
        {
          props.trainerName ? 
          <UploadFile trainerName={props.trainerName.toString().toLowerCase().replace(' ', '-')} exercise={props.exercise}/>
          :
          <p> Must set trainer name</p>
        }
      </div>
    </Modal>
  )
}

const createOption = (exercise) => ({
  label: exercise.present_name,
  value: exercise._id || exercise.present_name,
});

function CreatableAdvanced(props) {
  const [isLoading, setIsLoading] = useState(false)

  const handleCreate = (inputValue) => {
    setIsLoading(true)
    props.setValue(inputValue)
    props.showModal()
    // setTimeout(() => {
    //   const { options } = this.state;
    //   const newOption = createOption(inputValue);
    //   console.log(newOption);
    //   console.groupEnd();
    //   this.setState({
    //     isLoading: false,
    //     options: [...options, newOption],
    //     value: newOption,
    //   });
    // }, 1000);
  };

  return (
    <CreatableSelect
      isClearable
      isDisabled={isLoading}
      isLoading={isLoading}
      onChange={(e) => props.setValue(e)} 
      onCreateOption={handleCreate}
      options={props.options}
      value={props.value}
    />
  );
}

function UploadFile(props) {
  const [success, setSuccess] = useState(false)
  const [url, setUrl] = useState(undefined)
  const [fileName, setFileName] = useState(undefined)
  const uploadInput = useRef(null);
  
  const handleChange = (evn) => {
    setSuccess(false)
    setUrl(undefined)

    if (uploadInput.current.files) {
      setFileName(uploadInput.current.files[0].name.split('.')[0])
    }
  }

  // Perform the upload
  const handleUpload = (ev) => {
    console.log(uploadInput.current);
    let file = uploadInput.current.files[0];
    // Split the filename to get the name and type
    let fileParts = uploadInput.current.files[0].name.split('.');
    let fileName = fileParts[0];
    let fileType = fileParts[1];

    axios.post(`${config.URL}/api/workout/sign_s3`,{
      fileName : fileName,
      fileType : fileType,
      trainerName: props.trainerName,
      exercise: props.exercise,
      data: file
    })
    .then(response => {
      var returnData = response.data.data.returnData;
      var signedRequest = returnData.signedRequest;
      var url = returnData.url;
      setUrl(url)
      console.log("Recieved a signed request " + signedRequest);
      
     // Put the fileType in the headers for the upload
      var options = {
        headers: { 'Content-Type': fileType, 'x-amz-acl': 'public-read' }
      };

      console.log("file",signedRequest, file,options);
      axios.put(signedRequest,file,options)
      .then(result => {
        console.log("Response from s3")
        setSuccess(true)
      })
      .catch(error => {
        alert("ERROR " + JSON.stringify(error));
      })
    })
    .catch(error => {
      console.log(123);
      alert(JSON.stringify(error));
    })
  }
  
  const Success_message = () => (
        <div style={{padding:50}}>
          <h3 style={{color: 'green'}}>SUCCESSFUL UPLOAD</h3>
          <a href={url}>Access the file here</a>
          <br/>
        </div>
  )

  return (
    <div className="App">
      <center>
        <h1>UPLOAD A FILE</h1>
        {success ? <Success_message/> : null}
        <label className="custom-file-upload">
            <input type="file" style={{width: "30vw"}} className="select-motivation" onChange={handleChange} ref={uploadInput}/>
            <i className="fa fa-cloud-upload"></i> Upload Video
        </label>
        {/* <input style={{width: "30vw"}} className="select-motivation" onChange={handleChange} ref={uploadInput} type="file"/> */}
        <p>{fileName ? fileName : ''} </p>
        <Button onClick={handleUpload} className="mr-3 savebtn">UPLOAD</Button>
      </center>
    </div>
  );
}
